import React from "react";
import DatePicker from "react-datepicker";
import { TextField } from "@material-ui/core";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import PropTypes from "prop-types";
// to fix zindex
import "./DatePickerWrapped.css";
// import ClearSVG from "material-ui/svg-icons/content/clear";

const DatePickerWrapped = props => {
  const txtInput = (
    <TextField
      key="dateFrom"
      fullWidth
      floatinglabelfixed="true"
      disabled={props.disabled}
      label={props.floatingLabelText}
      placeholder="yyyy-mm-dd"
      value={new Date(props.value)}
      InputLabelProps={{
        shrink: true
      }}
    />
  );
  return (
    <DatePicker
      isClearable
      customInput={txtInput}
      disabled={props.disabled}
      selected={props.value ? moment(props.value) : null}
      maxDate={props.maxDate ? moment(props.maxDate) : moment("2027-01-01")}
      minDate={props.minDate ? moment(props.minDate) : moment("2005-01-01")}
      placeholderText={props.format.toLowerCase()}
      onChange={props.onChange}
      onChangeRaw={e => {
        const val = e.target.match;
        if (moment(val, props.format).format(props.format) === val)
          props.onChange(e.target.value);
      }}
      dateFormat={props.format}
      showYearDropdown
      disabledKeyboardNavigation
      dateFormatCalendar="MMMM"
      scrollableYearDropdown
      yearDropdownItemNumber={10}
    />
  );
};
DatePickerWrapped.propTypes = {
  disabled: PropTypes.bool,
  value: PropTypes.string,
  format: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  minDate: PropTypes.string,
  maxDate: PropTypes.string,
  floatingLabelText: PropTypes.string
};
DatePickerWrapped.defaultProps = {
  disabled: false,
  format: "YYYY-MM-DD",
  value: null,
  minDate: null,
  maxDate: null,
  floatingLabelText: null
};

export default DatePickerWrapped;
